/**
 * PILLAR 1 — Sheet List Trust Badge.
 *
 * Tiny pill rendered next to each sheet in the project sheet list.
 * Communicates trust state in 2-3 words. Tap deep-links to the action.
 */
import { AlertTriangle, Check, X } from "lucide-react";

const STATE_STYLE = {
  ready: {
    bg: "rgba(16,185,129,0.10)",
    border: "rgba(16,185,129,0.45)",
    text: "#047857",
    Icon: Check,
  },
  needs_action: {
    bg: "rgba(245,158,11,0.12)",
    border: "rgba(245,158,11,0.50)",
    text: "#b45309",
    Icon: AlertTriangle,
  },
  not_ready: {
    bg: "rgba(239,68,68,0.12)",
    border: "rgba(239,68,68,0.50)",
    text: "#b91c1c",
    Icon: X,
  },
  unknown: {
    bg: "rgba(107,114,128,0.10)",
    border: "rgba(107,114,128,0.35)",
    text: "#374151",
    Icon: AlertTriangle,
  },
};

export function TrustBadge({ state = "unknown", label, testid }) {
  const s = STATE_STYLE[state] || STATE_STYLE.unknown;
  const Icon = s.Icon;
  return (
    <span
      className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-mono uppercase tracking-wider whitespace-nowrap"
      style={{
        background: s.bg,
        border: `1px solid ${s.border}`,
        color: s.text,
      }}
      data-testid={testid || "trust-badge"}
      data-trust-state={state}
    >
      <Icon size={10} strokeWidth={2.5} />
      {label || state}
    </span>
  );
}

export default TrustBadge;
